export type UnitSystem = 'imperial' | 'metric';

export type UnitConversionValue = number | null | undefined;
export type UnitConversionValueWithUnitOnly = UnitConversionValue | 'unit-only';

export function toUnitSystem(unitSystem: UnitSystem): google.maps.UnitSystem {
  return unitSystem === 'metric' ? google.maps.UnitSystem.METRIC : google.maps.UnitSystem.IMPERIAL;
}

export interface FsTemperatureOptions {
  precision?: number;
  includeUnit?: boolean;
  sourceUnit?: UnitSystem;
}

export interface FsSpeedOptions {
  precision?: number;
  includeUnit?: boolean;
  sourceUnit?: UnitSystem;
}

export interface FsDistanceOptions {
  precision?: number;
  includeUnit?: boolean;
  sourceUnit?: UnitSystem;
}

export interface UnitInfo {
  symbol: string;
  name: string;
}

export interface UnitSystemConfig {
  system: UnitSystem;
  temperature: UnitInfo;
  speed: UnitInfo;
  distance: UnitInfo;
}

